"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));
const DialogActions_1 = __importDefault(require("@material-ui/core/DialogActions"));
const DialogContent_1 = __importDefault(require("@material-ui/core/DialogContent"));
const DialogTitle_1 = __importDefault(require("@material-ui/core/DialogTitle"));
const RadioGroup_1 = __importDefault(require("@material-ui/core/RadioGroup"));
const FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const Radio_1 = __importDefault(require("@material-ui/core/Radio"));
const useTheme_1 = __importDefault(require("@material-ui/core/styles/useTheme"));
const selectTheme_1 = __importDefault(require("../../actions/app/selectTheme"));
const theme_1 = require("../../domain/model/theme");
exports.default = ThemeSelector;
const options = [
    {
        name: "System default",
        value: theme_1.SelectedTheme.SystemDefault
    }, {
        name: "Light",
        value: theme_1.SelectedTheme.Light
    }, {
        name: "Dark",
        value: theme_1.SelectedTheme.Dark
    }
];
function ThemeSelector(props) {
    const dispatch = react_redux_1.useDispatch();
    const currentTheme = react_redux_1.useSelector((state) => state.appState.selectedTheme);
    const [value, setValue] = react_1.useState(currentTheme);
    const theme = useTheme_1.default();
    function handleChange(event) {
        const selectedTheme = parseInt(event.target.value);
        setValue(selectedTheme);
    }
    function handleOk() {
        dispatch(selectTheme_1.default(value));
        props.onClose();
    }
    return (react_1.default.createElement(Dialog_1.default, { open: true },
        react_1.default.createElement(DialogTitle_1.default, null, "Select theme"),
        react_1.default.createElement(DialogContent_1.default, { dividers: true },
            react_1.default.createElement(RadioGroup_1.default, { name: "theme", value: value, onChange: handleChange }, options.map((option) => (react_1.default.createElement(FormControlLabel_1.default, { key: option.value, value: option.value, control: react_1.default.createElement(Radio_1.default, null), label: option.name, color: theme.colors.buttonColor }))))),
        react_1.default.createElement(DialogActions_1.default, null,
            react_1.default.createElement(Button_1.default, { onClick: props.onClose }, "Cancel"),
            react_1.default.createElement(Button_1.default, { onClick: handleOk }, "Ok"))));
}
